import { directive as clickOutside } from 'vue-on-click-outside';

export default {
    clickOutside
};
